import { paramsToString } from '@/services/http/httpClient'
import billmaHttpClient from '@/services/http/billmaHttpClient'

/* eslint-disable */
export const apiGetFlowData = sinisterId => {
  const params = new URLSearchParams()
  params.set('claimID', sinisterId)

  let token = sessionStorage.getItem('mavAuth')

  if (token) {
    token = token.replace('Token', 'Bearer')
    sessionStorage.setItem('mavAuth', token)
  }

  return billmaHttpClient
    .get(`/machine/api/claim/state${paramsToString(params)}`)
    .finally(() => {      
      let token = sessionStorage.getItem('mavAuth')
  
      token = token.replace('Bearer', 'Token')
      sessionStorage.setItem('mavAuth', token)
    })
  // return new Promise((resolve) => {
  //   return resolve({
  //     "externalId": "testMobilier1",
  //     "state": "COMPENSATION_MOBILIER",
  //     "transitions": [
  //       "FINISHED"
  //     ],
  //     "flow": "gag",
  //     "lang": "fr",
  //     "options": {
  //       "image_required": false,
  //       "content": []
  //     }
  //   })
  // })
}

export const apiGetTransitionToNextState = (sinisterId, event, options) => {
  const params = new URLSearchParams()
  params.set('claimID', sinisterId)

  let token = sessionStorage.getItem('mavAuth')

  if (token) {
    token = token.replace('Token', 'Bearer')
    sessionStorage.setItem('mavAuth', token)
  }

  if (event) params.set('event', event)
  if (options) {
    Object.keys(options).forEach(option => {
      params.set(option, options[option])
    })
  }
  return billmaHttpClient
    .get(`/machine/api/claim/state/next${paramsToString(params)}`)
    .finally(() => {
      let token = sessionStorage.getItem('mavAuth')
  
      token = token.replace('Bearer', 'Token')
      sessionStorage.setItem('mavAuth', token)
    })
}
